// apps/web/src/components/landing-v2/MadeWithPulls.tsx
import { ScrollRail } from '../ui/ScrollRail'
import { landingMocks } from '../../data/landingMocks'

const CARD_TITLES: Record<string, string> = {
  'the-fool': 'The Fool',
  'the-magician': 'The Magician',
  'the-high-priestess': 'The High Priestess',
  'the-empress': 'The Empress',
  'the-lovers': 'The Lovers',
  'the-tower': 'The Tower',
  'the-star': 'The Star',
  'the-moon': 'The Moon',
  'the-sun': 'The Sun',
  'the-world': 'The World',
  death: 'Death',
  judgement: 'Judgement',
}

/** Anonymized "Made with The Cosmic Finder" strip — last 72 hours.
 *  Wrapped in <ScrollRail mode="shadow"> so on narrow viewports the edge
 *  fades make it discoverable as a horizontal rail. Consumes
 *  landingMocks.recentPulls. */
export function MadeWithPulls() {
  return (
    <section
      data-section="made-with-pulls"
      className="mx-auto max-w-[1280px] px-5 pt-12 pb-4 md:px-8"
    >
      <p className="reveal text-xs uppercase tracking-[0.3em] text-text-muted">
        Questions people bring to the cards
      </p>
      <div className="reveal mt-5">
        <ScrollRail mode="shadow">
          {landingMocks.recentPulls.map((p, i) => (
            <article
              key={`${p.cardId}-${i}`}
              className="scroll-rail-item shrink-0 rounded-lg border border-hairline bg-cosmic-card p-4"
              style={{ width: '240px' }}
            >
              <img
                src={`/cards/${p.cardId}.webp`}
                alt=""
                loading="lazy"
                className="mt-3 h-32 w-full rounded-md object-contain"
              />
              <p className="mt-3 text-sm text-text-primary">
                {CARD_TITLES[p.cardId] ?? p.cardId}
              </p>
              <p className="mt-1 font-display text-sm italic text-text-secondary">
                &ldquo;{p.question}&rdquo;
              </p>
            </article>
          ))}
        </ScrollRail>
      </div>
    </section>
  )
}
